(function () {
  'use strict';
  var __ids = window.CM_COMM_IDS || [];
  for (var __k = 0; __k < __ids.length; __k++) { __ccInit(__ids[__k]); }
  function __ccInit(__id) {
  var root = document.getElementById(__id);
  if (!root || root.dataset.ccInit) return;
  root.dataset.ccInit = '1';

  var track = root.querySelector('[data-cc-track]');
  var scroller = root.querySelector('.cm-comm-scroller');
  var items = Array.prototype.slice.call(track.querySelectorAll('[data-cc-item]'));
  if (!items.length) { root.hidden = true; return; }
  var isMobile = window.matchMedia('(max-width: 899px)');
  var isMobileCarousel = window.matchMedia('(max-width: 767px)');

  /* ── Boucle infinie (mobile) : clones aux deux bouts, teleportation
     invisible quand le scroll se pose sur un clone ── */
  var CLONES = 2;
  var looped = isMobileCarousel.matches && items.length > CLONES;
  var allFrames = items.map(function (it) { return it.querySelector('[data-cc-frame]'); });
  if (looped) {
    var makeClone = function (item) {
      var c = item.cloneNode(true);
      c.removeAttribute('data-cc-item');
      c.dataset.ccCloneOf = String(items.indexOf(item));
      return c;
    };
    items.slice(-CLONES).reverse().forEach(function (it) {
      track.insertBefore(makeClone(it), track.firstChild);
    });
    items.slice(0, CLONES).forEach(function (it) {
      track.appendChild(makeClone(it));
    });
    track.querySelectorAll('[data-cc-clone-of]').forEach(function (c) {
      allFrames.push(c.querySelector('[data-cc-frame]'));
    });
  }
  function centerCard(el, smooth) {
    var x = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    if (smooth) track.scrollTo({ left: x, behavior: 'smooth' });
    else track.scrollLeft = x;
  }
  function centeredChild() {
    var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
    var best = null, dist = Infinity;
    Array.prototype.forEach.call(track.children, function (ch) {
      var r = ch.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - mid);
      if (d < dist) { dist = d; best = ch; }
    });
    return best;
  }
  function loopCheck() {
    if (!looped) return;
    var c = centeredChild();
    if (c && c.dataset.ccCloneOf !== undefined) {
      centerCard(items[parseInt(c.dataset.ccCloneOf, 10)], false);
    }
  }
  if (looped) {
    requestAnimationFrame(function () { centerCard(items[0], false); });
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', loopCheck);
    } else {
      var lt;
      track.addEventListener('scroll', function () {
        clearTimeout(lt);
        lt = setTimeout(loopCheck, 120);
      }, { passive: true });
    }
  }

  /* ── Flèches + fondu de bord (desktop) ── */
  var nav = root.querySelector('[data-cc-nav]');
  var prevBtn = root.querySelector('[data-cc-prev]');
  var nextBtn = root.querySelector('[data-cc-next]');
  function stepWidth() {
    var card = track.querySelector('.cm-comm-card');
    return card ? card.getBoundingClientRect().width + 12 : 312;
  }
  function updateNav() {
    var overflow = track.scrollWidth > track.clientWidth + 8;
    nav.hidden = !overflow;
    var max = track.scrollWidth - track.clientWidth - 4;
    var atEnd = track.scrollLeft >= max;
    scroller.classList.toggle('has-more', overflow && !atEnd);
    if (!overflow) return;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = atEnd;
  }
  prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepWidth() * 2, behavior: 'smooth' }); });
  nextBtn.addEventListener('click', function () { track.scrollBy({ left: stepWidth() * 2, behavior: 'smooth' }); });
  var tick = false;
  track.addEventListener('scroll', function () {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () { tick = false; updateNav(); });
  }, { passive: true });
  window.addEventListener('resize', updateNav);
  updateNav();

  /* ── Previews muettes en boucle sur les cartes (vraies et clones) ── */
  var viewerOpen = false;
  var docked = false;
  function ensurePreview(frame) {
    var v = frame.querySelector('video.cm-comm-preview');
    if (v) return v;
    if (!frame.dataset.previewSrc) return null;
    v = document.createElement('video');
    v.className = 'cm-comm-preview';
    v.src = frame.dataset.previewSrc;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.preload = 'auto';
    v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1;
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    frame.insertBefore(v, frame.querySelector('.cm-comm-open'));
    return v;
  }
  var visibleFrames = [];
  function syncPreviews() {
    visibleFrames.forEach(function (frame) {
      var v = ensurePreview(frame);
      if (!v) return;
      if (viewerOpen && !docked) { v.pause(); return; }
      v.play().catch(function () {});
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var frame = e.target;
        var i = visibleFrames.indexOf(frame);
        if (e.isIntersecting) {
          if (i < 0) visibleFrames.push(frame);
          var v = ensurePreview(frame);
          if (v && !(viewerOpen && !docked)) v.play().catch(function () {});
        } else {
          if (i >= 0) visibleFrames.splice(i, 1);
          var pv = frame.querySelector('video.cm-comm-preview');
          if (pv) pv.pause();
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    allFrames.forEach(function (f) { io.observe(f); });
  }

  /* ── Viewer réels ── */
  var vlb = root.querySelector('[data-cc-vlb]');
  document.body.appendChild(vlb); /* échappe aux stacking contexts du thème */
  var slidesEl = vlb.querySelector('[data-cc-slides]');
  var progressWrap = vlb.querySelector('[data-cc-progresswrap]');
  var progress = vlb.querySelector('[data-cc-progress]');
  var muteBtn = vlb.querySelector('[data-cc-mute]');
  var dockBtn = vlb.querySelector('[data-cc-dock]');
  var closeBtn = vlb.querySelector('[data-cc-close]');
  /* i18n : libelles des etats alternes, poses par le Liquid du composant
     (CONVENTION section 4). Repli code, jamais undefined a l'ecran. */
  var lblSonCouper = (muteBtn && muteBtn.getAttribute('data-cc-label-son-couper')) || 'Couper le son';
  var lblSonRemettre = (muteBtn && muteBtn.getAttribute('data-cc-label-son-remettre')) || 'Remettre le son';
  var lblReduire = (dockBtn && dockBtn.getAttribute('data-cc-label-reduire')) || 'Réduire le lecteur';
  var lblAgrandir = (dockBtn && dockBtn.getAttribute('data-cc-label-agrandir')) || 'Agrandir le lecteur';

  var vPrev = vlb.querySelector('[data-cc-vprev]');
  var vNext = vlb.querySelector('[data-cc-vnext]');
  var built = false;
  var slides = [];
  var active = -1;
  var seeking = false;
  var userMuted = false;
  var hintSeen = false;

  /* Un SEUL élément <video> réutilisé pour toutes les slides : une fois
     autorisé à jouer avec le son (clic d'ouverture), il garde cette
     autorisation ; un élément neuf par slide la perdrait. */
  var sharedVideo = null;
  function getSharedVideo() {
    if (sharedVideo) return sharedVideo;
    var v = document.createElement('video');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    v.addEventListener('timeupdate', function () {
      if (!seeking && v.duration) progress.value = (v.currentTime / v.duration) * 100;
    });
    v.addEventListener('ended', function () {
      if (active < items.length - 1) go(1);
      else { v.currentTime = 0; v.play().catch(function () {}); }
    });
    v.addEventListener('click', function () {
      if (docked) return;
      if (v.paused) v.play().catch(function () {}); else v.pause();
    });
    sharedVideo = v;
    return v;
  }
  function tryPlay(v) {
    v.muted = userMuted;
    setMuteIcon(userMuted);
    v.play().catch(function () {
      v.muted = true;
      setMuteIcon(true);
      v.play().catch(function () {});
    });
  }
  function setMuteIcon(muted) {
    muteBtn.querySelectorAll('[data-icon-on]').forEach(function (e) { e.toggleAttribute('hidden', muted); });
    var off = muteBtn.querySelector('[data-icon-off]');
    if (off) off.toggleAttribute('hidden', !muted);
    muteBtn.setAttribute('aria-label', muted ? lblSonRemettre : lblSonCouper);
  }

  function slideFor(item, i) {
    var frame = item.querySelector('[data-cc-frame]');
    var slide = document.createElement('div');
    slide.className = 'cm-vlb-slide';
    slide.dataset.idx = i;
    var poster = frame.querySelector('img');
    if (poster) {
      var im = document.createElement('img');
      im.className = 'cm-vlb-media';
      im.src = frame.dataset.photoSrc || poster.currentSrc || poster.src;
      im.alt = poster.alt || '';
      slide.appendChild(im);
    }
    if (item.dataset.handle) {
      var h = document.createElement('div');
      h.className = 'cm-vlb-slide-handle';
      h.textContent = item.dataset.handle;
      slide.appendChild(h);
    }
    if (item.dataset.productUrl) {
      var chip = document.createElement('a');
      chip.className = 'cm-vlb-chip';
      chip.href = item.dataset.productUrl;
      var html = '';
      if (item.dataset.productImg) html += '<img src="' + item.dataset.productImg + '" alt="" width="52" height="52">';
      html += '<span class="cm-comm-chip-info"><span class="cm-comm-chip-title"></span><span class="cm-comm-chip-price"></span></span>';
      html += '<span class="cm-vlb-chip-arrow" aria-hidden="true">→</span>';
      chip.innerHTML = html;
      chip.querySelector('.cm-comm-chip-title').textContent = item.dataset.productTitle || '';
      chip.querySelector('.cm-comm-chip-price').innerHTML =
        (item.dataset.productCompare ? '<s>' + item.dataset.productCompare + '</s> ' : '') +
        (item.dataset.productPrice || '');
      slide.appendChild(chip);
    }
    return slide;
  }

  function build() {
    if (built) return;
    built = true;
    items.forEach(function (item, i) { slides.push(slideFor(item, i)); slidesEl.appendChild(slides[i]); });
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.6) {
          setActive(parseInt(e.target.dataset.idx, 10));
        }
      });
    }, { root: slidesEl, threshold: 0.6 });
    slides.forEach(function (s) { sio.observe(s); });
  }

  function setActive(i) {
    if (i === active || i < 0 || i >= items.length) return;
    active = i;
    var frame = items[i].querySelector('[data-cc-frame]');
    var slide = slides[i];
    var v = getSharedVideo();
    v.pause();
    if (frame.dataset.videoSrc) {
      var abs = new URL(frame.dataset.videoSrc, location.href).href;
      if (v.src !== abs) v.src = frame.dataset.videoSrc;
      else v.currentTime = 0;
      slide.appendChild(v);
      progress.value = 0;
      progressWrap.hidden = false;
      muteBtn.hidden = false;
      tryPlay(v);
    } else {
      if (v.parentNode) v.parentNode.removeChild(v);
      progressWrap.hidden = true;
      muteBtn.hidden = true;
    }
    vPrev.disabled = active <= 0;
    vNext.disabled = active >= items.length - 1;
  }

  /* Nudge d'onboarding : leve brievement la pile pour montrer la slide
     suivante (le geste de swipe se comprend sans texte). */
  function nudge() {
    if (!viewerOpen || docked) return;
    var base = slidesEl.scrollTop;
    var amp = Math.round(slidesEl.clientHeight * 0.09);
    var t0 = null;
    slidesEl.style.scrollSnapType = 'none';
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function frame(ts) {
      if (!t0) t0 = ts;
      var t = (ts - t0) / 950;
      if (t >= 1 || !viewerOpen) {
        slidesEl.scrollTop = base;
        slidesEl.style.scrollSnapType = '';
        return;
      }
      var phase = t < 0.45 ? ease(t / 0.45) : t < 0.62 ? 1 : 1 - ease((t - 0.62) / 0.38);
      slidesEl.scrollTop = base + amp * phase;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function go(dir) {
    var next = active + dir;
    if (next < 0 || next >= items.length) return;
    slidesEl.scrollTo({ top: next * slidesEl.clientHeight, behavior: 'smooth' });
  }

  function open(i) {
    build();
    viewerOpen = true;
    docked = false;
    vlb.classList.remove('is-docked');
    document.body.classList.add('cm-vlb-open');
    vlb.hidden = false;
    active = -1;
    slidesEl.scrollTop = i * slidesEl.clientHeight;
    setActive(i);
    syncPreviews();
    if (isMobile.matches && !hintSeen && items.length > 1 && i < items.length - 1) {
      hintSeen = true;
      setTimeout(nudge, 900);
    }
    document.addEventListener('keydown', onKey);
    closeBtn.focus();
  }
  function close() {
    vlb.hidden = true;
    vlb.classList.remove('is-docked');
    if (sharedVideo) sharedVideo.pause();
    active = -1;
    document.body.classList.remove('cm-vlb-open');
    document.removeEventListener('keydown', onKey);
    viewerOpen = false;
    docked = false;
    syncPreviews();
  }
  function dock() {
    docked = true;
    vlb.classList.add('is-docked');
    document.body.classList.remove('cm-vlb-open');
    dockBtn.setAttribute('aria-label', lblAgrandir);
    syncPreviews();
  }
  function undock() {
    docked = false;
    vlb.classList.remove('is-docked');
    document.body.classList.add('cm-vlb-open');
    dockBtn.setAttribute('aria-label', lblReduire);
    syncPreviews();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (docked) return;
    else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(-1); }
  }

  progress.addEventListener('input', function () {
    if (!sharedVideo || !sharedVideo.duration) return;
    seeking = true;
    sharedVideo.currentTime = (progress.value / 100) * sharedVideo.duration;
  });
  progress.addEventListener('change', function () { seeking = false; });
  muteBtn.addEventListener('click', function () {
    if (!sharedVideo) return;
    userMuted = !sharedVideo.muted;
    sharedVideo.muted = userMuted;
    setMuteIcon(userMuted);
  });
  dockBtn.addEventListener('click', function () { docked ? undock() : dock(); });
  closeBtn.addEventListener('click', close);
  vPrev.addEventListener('click', function () { go(-1); });
  vNext.addEventListener('click', function () { go(1); });
  vlb.querySelector('[data-cc-backdrop]').addEventListener('click', close);
  vlb.querySelector('[data-cc-box]').addEventListener('click', function (e) {
    if (docked && !e.target.closest('button')) undock();
  });

  function bindOpen(el, idx) {
    var frame = el.querySelector('[data-cc-frame]');
    frame.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      open(idx);
    });
    frame.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target === frame) {
        e.preventDefault();
        open(idx);
      }
    });
  }
  items.forEach(function (item, i) { bindOpen(item, i); });
  track.querySelectorAll('[data-cc-clone-of]').forEach(function (c) {
    bindOpen(c, parseInt(c.dataset.ccCloneOf, 10));
  });
  }
})();
